// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__29LUy","notes":"Notes_notes__3-Kb5","note":"Notes_note__ziyhf","markdown":"Notes_markdown__1HZVO"};